// @ts-nocheck
import { getSessionId } from '@aspendental/shared-utils/utils';

import { objectKeyToSnake } from './camelCaseToSnake';

import { Maybe, IglobalThis } from '@shared-components/types';

declare global {
	// eslint-disable-next-line @typescript-eslint/no-namespace
	namespace globalThis {
		let dataLayer: Array<Record<string, unknown>>;
		let dispatchDataLayer: (config: IDataLayerEventConfig) => void;
	}
}

globalThis.dispatchDataLayer = (config: IDataLayerEventConfig) => {
	dataLayerConfig({
		...config,
	});
};

export interface IDataLayerEventConfig {
	[key: string]: Maybe<string | boolean | number | undefined | Record<string, unknown>>;
}

export const dataLayerConfig = (eventConfig?: IDataLayerEventConfig) => {
	const config = eventConfig ?? { event: '' };
	// transform object keys that come from contentful to snake case because InfoTrust
	// newConfig should be the same as eventConfig, just snake_case
	const newConfig = objectKeyToSnake(config);

	const { page_origin_url } = newConfig;

	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	globalThis.dataLayer = (globalThis as IglobalThis).dataLayer || [];

	const defaultConfig = {
		tag_session_id: getSessionId(),
		platform: 'NextJS',
		page_origin_name: globalThis?.document?.title,
		page_origin_url: page_origin_url ?? globalThis?.location?.href,
	};

	// Removing contentful_metadata and sys are temporary
	// those keys are only present due to how the manual events are needed to be used
	// will be deprecated during a Contentful clean up
	Object.keys(newConfig).forEach(
		(key) =>
			(key === '__typename' ||
				key === 'contentful_metadata' ||
				key === 'sys' ||
				newConfig[key] === undefined ||
				newConfig[key] === null ||
				newConfig[key] === '') &&
			delete newConfig[key]
	);

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
	globalThis.dataLayer.push({
		...defaultConfig,
		...newConfig,
	});
};

export const mapSearchClickEvent = (params?: { numResults?: number }) => {
	const eventConfig = {
		event: 'mapbox_search_click',
		...(params && 'numResults' in params ? { num_results: params.numResults } : {}),
	};

	dataLayerConfig(eventConfig);
};
